import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_BUSINESS_ENTITIES } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'
import createPaginatedGetAction from '@/store/helpers/createPaginatedGetAction'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const businessEntities = {
  namespaced: true,
  state: buildInitialState({
    businessEntityList: [],
    totalRecords: 0
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setBusinessEntities: (state, businessEntities) => {
      state.businessEntityList = businessEntities
    },
    setPaginatedBusinessEntities (state, { result, totalRecords }) {
      state.businessEntityList = result
      state.totalRecords = totalRecords
    }
  },
  actions: {
    getBusinessEntities: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting business entities, please wait...' })

      return api.doGet({ path: PATH_BUSINESS_ENTITIES, parameters: filters })
        .then(json => json.data)
        .then(businessEntities => {
          commit('updateStatus', { status: COMPLETE })
          commit('setBusinessEntities', businessEntities)
          return businessEntities
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to select business entities')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getBusinessEntityOptions ({ dispatch }, filters = {}) {
      return api.doGet({ path: PATH_BUSINESS_ENTITIES, parameters: filters })
        .then(json => json.data || [])
        .catch(() => {
          notifyError(dispatch, 'Unable to load business entities')
          return []
        })
    },
    getFieldsWithFilters: ({ dispatch, rootGetters }) => {
      return dispatch('getBusinessEntities', { ...rootGetters['businessEntityFilters/getSearchObject'] })
    },
    getBusinessEntitiesWithFiltersPaginated ({ dispatch, rootGetters }, paginationParams = {}) {
      return dispatch('getBusinessEntitiesPaginated', {
        ...rootGetters['businessEntityFilters/getSearchObject'],
        ...paginationParams
      })
    },
    getBusinessEntitiesPaginated: createPaginatedGetAction(PATH_BUSINESS_ENTITIES, 'setPaginatedBusinessEntities', 'Unable to get business entities')
  }
}

export default businessEntities
